import image1 from "../img/imageneslav.jpg";
import image2 from "../img/img2.jpeg";
import image3 from "../img/img3.jpeg";
import image4 from "../img/img4.jpeg";
import image5 from "../img/img5.jpeg";
import image6 from "../img/osito.jpeg";
import image7 from "../img/acolchadoM.jpeg";
import image8 from "../img/LavadorasM.jpeg";
import image11 from "../img/secadoraMM.jpeg";
const ImagesLav = () => {
  return (
    <div className="container-imgs">
      <img
        src={image7}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
      <img
        src={image8}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
      <img
        src={image1}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
      <img
        src={image2}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
      <img
        src={image3}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
      <img
        src={image4}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
      <img
        src={image5}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
      <img
        src={image6}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
      <img
        src={image11}
        alt=""
        className="wow animate__animated animate__fadeIn"
      />
    </div>
  );
};

export default ImagesLav;
